import React, { useState, useEffect } from "react";
import htmlToDraft from "html-to-draftjs";
import draftToHtml from "draftjs-to-html";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const defaultToolbarOptions = {
  options: ["inline", "blockType", "list"],
  inline: {
    options: ["bold", "italic", "underline"],
  },
  list: {
    options: ["unordered", "ordered"],
  },
  blockType: {
    options: ["Normal", "H1", "H2", "H3", "H4", "H5", "H6"],
  },
};

const RichTextEditor = ({
  readOnly = false,
  placeholder = "",
  onBlur = null,
  initialContent = null,
  onContentChange = null,
  toolbarOptions = defaultToolbarOptions,
}) => {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (initialContent) {
      try {
        const blocksFromHtml = htmlToDraft(initialContent);
        const { contentBlocks, entityMap } = blocksFromHtml;

        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap
        );

        setEditorState(EditorState.createWithContent(contentState));
      } catch (error) {
        console.error("Error loading initial content:", error);
      }
    }
  }, [initialContent]);

  const handleEditorChange = (state) => {
    setEditorState(state);
    if (onContentChange) {
      const contentState = state.getCurrentContent();
      const html = draftToHtml(convertToRaw(contentState));
      onContentChange(html);
    }
  };

  return (
    <div className="w-100 text-editor">
      <Editor
        readOnly={readOnly}
        toolbar={toolbarOptions}
        placeholder={placeholder}
        editorState={editorState}
        editorClassName="editor-class"
        wrapperClassName="wrapper-class"
        toolbarClassName="toolbar-class"
        onEditorStateChange={handleEditorChange}
        onBlur={onBlur}
      />
    </div>
  );
};

export default RichTextEditor;
